import { Alert } from 'antd'
import React from 'react'

class ErrorAlert extends React.Component {

  render () {
    const {errors} = this.props

    return (
      <div className="qw-absolute qw-left-0 qw-bottom-0 qw-m-small">
        {
          errors.map((error, index) => <Alert
            message={error}
            key={index}
            className="qw-m-small"
            type="error"
            closable
            showIcon
          />)
        }
      </div>
    )
  }
}

export default ErrorAlert


// WEBPACK FOOTER //
// ./src/app/components/common/ErrorAlert.js